import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';
import { FIELDS } from 'modules/cm/fields/types';
import { Nullable } from 'utils/types';

const exportFunc = (state: State, action: Action) => {
  return {
    [ACTION_TYPES.SET_READONLY_FIELDS.toString()]: () => ({
      ...state,
      readonlyFields: action.payload[0] as State['readonlyFields'],
    }),

    [ACTION_TYPES.SET_PEPPER_UPLOAD_DATE.toString()]: () => ({
      ...state,
      readonlyFields: {
        ...state.readonlyFields,
        admin: {
          ...state.readonlyFields[FIELDS.ADMIN_PREFIX],
          pepperUploadDate: action.payload[0] as Nullable<string>,
        },
      },
    }),
  };
};
export default exportFunc;
